export default {
  state: {
    selected: {
      leg1: {},
      leg2: {}
    },
    selectedGround: {
      leg1: {
        pickup: 0,
        dropoff: 0
      },
      leg2: {
        pickup: 0,
        dropoff: 0
      }
    }
  },
  mutations: {
    setSelectedData (state, data) {
      for (let field in data) {
        state.selected[field] = data[field]
      }
    },
    updateSelectedData (state, data) {
      for (let field in data.fields) {
        state.selected[data.leg][field] = data.fields[field]
      }
    },
    setSelectedGroundData (state, data) {
      for (let field in data) {
        state.selectedGround[field] = data[field]
      }
    },
    updateSelectedGroundData (state, data) {
      for (let field in data.fields) {
        state.selectedGround[data.leg][field] = data.fields[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/selected.js